var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpreadsheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_spreadsheet_file",
    d: "M10.25,4A2.261,2.261,0,0,0,8,6.25v15.5A2.261,2.261,0,0,0,10.25,24h11.5A2.261,2.261,0,0,0,24,21.75V11.25a.75.75,0,0,0-.22-.53l-.008-.008L17.28,4.22A.75.75,0,0,0,16.75,4Zm0,1.5H16V9.75A2.261,2.261,0,0,0,18.25,12H22.5v9.75a.739.739,0,0,1-.75.75H10.25a.739.739,0,0,1-.75-.75V6.25A.739.739,0,0,1,10.25,5.5ZM17.5,6.561,21.439,10.5H18.25a.739.739,0,0,1-.75-.75ZM12.25,14a.75.75,0,1,0,0,1.5h2.5a.75.75,0,1,0,0-1.5Zm5,0a.75.75,0,1,0,0,1.5h2.5a.75.75,0,1,0,0-1.5Zm-5,2.5a.75.75,0,1,0,0,1.5h2.5a.75.75,0,1,0,0-1.5Zm5,0a.75.75,0,1,0,0,1.5h2.5a.75.75,0,1,0,0-1.5Zm-5,2.5a.75.75,0,1,0,0,1.5h2.5a.75.75,0,1,0,0-1.5Zm5,0a.75.75,0,1,0,0,1.5h2.5a.75.75,0,1,0,0-1.5Z",
    transform: "translate(-8 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadsheet);
export default __webpack_public_path__ + "static/media/spreadsheet.f1ce1d92914d362718d2aa142e000130.svg";
export { ForwardRef as ReactComponent };